/* =========================================================
   Sportsndeco.com — Moteur "CEINTURE" de champion (refonte premium 2026-07-11).
   Sangle cuir surpiquee + 4 plaques biseautees + plaque bouclier centrale
   (couronne de lauriers, etoile en relief, banderole nom). Or metallique via
   degrades (aucun <filter>). Parite aperçu/print.
   API : SNCombatBelt.render(data, opts) -> string SVG
     data : { name, title, org, weight, date, discipline }
     opts : { palette:"nuit"|"noir"|"ring"|"craie" }
   ========================================================= */
(function(){
  var PALETTES = {
    nuit:  { label:'Nuit',  bg:'#0B1B33', bg2:'#050D1A', gold:'#E8B04B', goldD:'#6B4A12', goldL:'#FFF0C0', ink:'#F4EEE0', muted:'#9FB2CE', accent:'#FF6B2C', strap:'#14213B', strapD:'#0A1122', strapL:'#2A4670', halo:'#16305A' },
    noir:  { label:'Noir',  bg:'#111418', bg2:'#05070A', gold:'#E8B04B', goldD:'#6B4A12', goldL:'#FFF0C0', ink:'#F2EFE9', muted:'#9AA0A8', accent:'#FF6B2C', strap:'#1B1F25', strapD:'#0A0C0F', strapL:'#2E343D', halo:'#242A32' },
    ring:  { label:'Ring',  bg:'#1A0E10', bg2:'#0C0608', gold:'#E8B04B', goldD:'#6B4A12', goldL:'#FFF0C0', ink:'#F6E9E4', muted:'#C79A93', accent:'#E23A32', strap:'#241214', strapD:'#120809', strapL:'#3A1D20', halo:'#3A1518' },
    craie: { label:'Craie', bg:'#F5F2EB', bg2:'#E4DBCB', gold:'#C8912E', goldD:'#6B4A12', goldL:'#F3D48A', ink:'#1E2430', muted:'#6B7280', accent:'#FF6B2C', strap:'#2A2A2E', strapD:'#131315', strapL:'#42424A', halo:'#E2D8C4' }
  };

  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function clean(s){ return (s==null?'':String(s)).trim(); }
  function f(n){ return (Math.round(n*10)/10); }
  function rad(d){ return d*Math.PI/180; }
  function starPath(cx,cy,rO,rI,rotDeg){
    var pts=[], n=5, rot=rad(rotDeg||0);
    for(var i=0;i<n*2;i++){ var r=(i%2)?rI:rO; var a=rot+i*Math.PI/n-Math.PI/2; pts.push(f(cx+r*Math.cos(a))+','+f(cy+r*Math.sin(a))); }
    return 'M'+pts.join('L')+'Z';
  }
  function shieldPath(cx,top,bottom,hw){
    var r=36;
    return 'M'+(cx-hw)+','+(top+r)
      +'Q'+(cx-hw)+','+top+' '+(cx-hw+r)+','+top
      +'L'+(cx+hw-r)+','+top
      +'Q'+(cx+hw)+','+top+' '+(cx+hw)+','+(top+r)
      +'L'+(cx+hw)+','+(bottom-110)
      +'Q'+(cx+hw)+','+(bottom-40)+' '+(cx+hw-70)+','+(bottom-14)
      +'Q'+cx+','+(bottom+16)+' '+(cx-hw+70)+','+(bottom-14)
      +'Q'+(cx-hw)+','+(bottom-40)+' '+(cx-hw)+','+(bottom-110)+'Z';
  }

  function render(data, opts){
    data = data||{};
    var key = (typeof opts==='string') ? opts : (opts && opts.palette);
    var pal = PALETTES[key] || PALETTES.nuit;

    var name = clean(data.name) || 'VOTRE NOM';
    var title = clean(data.title) || 'CHAMPION DU MONDE';
    var org = clean(data.org) || 'CHAMPION';
    var disc = clean(data.discipline) || 'CHAMPIONNAT';
    var weight = clean(data.weight);
    var date = clean(data.date);

    var nameU = esc(name.toUpperCase());
    var titleU = esc(title.toUpperCase());
    var orgU = esc(org.toUpperCase());
    var discU = esc(disc.toUpperCase());
    var weightU = weight ? esc(weight.toUpperCase()) : '';

    var nl = name.length;
    var nameSize = nl>18?23 : nl>14?27 : nl>10?33 : nl>6?39 : 44;
    var ol = org.length;
    var orgSize = ol>17?26 : ol>12?33 : 43;
    var tl = title.length;
    var titleSize = tl>22?23 : tl>16?28 : 33;
    var orgTopSize = ol>15?12:14;

    var shieldTopTxt = weight ? weightU : 'CHAMPION';
    var shieldBotTxt = discU;
    var bottomMeta = date ? ('EST. ' + esc(date)) : orgU;

    var DK = '#241703'; // brun foncé pour texte sur or (lisible sur les 4 palettes)

    // ---- DEFS ----
    var defs = '<defs>'
      +'<radialGradient id="be_halo" cx="0.5" cy="0.47" r="0.66">'
        +'<stop offset="0" stop-color="'+pal.halo+'"/>'
        +'<stop offset="0.55" stop-color="'+pal.bg+'"/>'
        +'<stop offset="1" stop-color="'+pal.bg2+'"/>'
      +'</radialGradient>'
      +'<linearGradient id="be_gold" x1="0" y1="0" x2="0" y2="1">'
        +'<stop offset="0" stop-color="'+pal.goldL+'"/>'
        +'<stop offset="0.30" stop-color="'+pal.gold+'"/>'
        +'<stop offset="0.52" stop-color="'+pal.goldD+'"/>'
        +'<stop offset="0.74" stop-color="'+pal.gold+'"/>'
        +'<stop offset="1" stop-color="'+pal.goldL+'"/>'
      +'</linearGradient>'
      +'<linearGradient id="be_goldH" x1="0" y1="0" x2="1" y2="0">'
        +'<stop offset="0" stop-color="'+pal.goldD+'"/>'
        +'<stop offset="0.16" stop-color="'+pal.gold+'"/>'
        +'<stop offset="0.5" stop-color="'+pal.goldL+'"/>'
        +'<stop offset="0.84" stop-color="'+pal.gold+'"/>'
        +'<stop offset="1" stop-color="'+pal.goldD+'"/>'
      +'</linearGradient>'
      +'<linearGradient id="be_star" x1="0" y1="0" x2="1" y2="1">'
        +'<stop offset="0" stop-color="'+pal.goldL+'"/>'
        +'<stop offset="0.42" stop-color="'+pal.gold+'"/>'
        +'<stop offset="1" stop-color="'+pal.goldD+'"/>'
      +'</linearGradient>'
      +'<linearGradient id="be_leaf" x1="0" y1="0" x2="0" y2="1">'
        +'<stop offset="0" stop-color="'+pal.goldL+'"/>'
        +'<stop offset="0.5" stop-color="'+pal.gold+'"/>'
        +'<stop offset="1" stop-color="'+pal.goldD+'"/>'
      +'</linearGradient>'
      +'<linearGradient id="be_leather" x1="0" y1="0" x2="0" y2="1">'
        +'<stop offset="0" stop-color="'+pal.strapL+'"/>'
        +'<stop offset="0.5" stop-color="'+pal.strap+'"/>'
        +'<stop offset="1" stop-color="'+pal.strapD+'"/>'
      +'</linearGradient>'
      +'<radialGradient id="be_enamel" cx="0.5" cy="0.38" r="0.72">'
        +'<stop offset="0" stop-color="'+pal.strapL+'"/>'
        +'<stop offset="1" stop-color="'+pal.strapD+'"/>'
      +'</radialGradient>'
      +'<radialGradient id="be_disc" cx="0.5" cy="0.36" r="0.75">'
        +'<stop offset="0" stop-color="'+pal.strap+'"/>'
        +'<stop offset="1" stop-color="'+pal.strapD+'"/>'
      +'</radialGradient>'
      +'<linearGradient id="be_gloss" x1="0" y1="0" x2="0" y2="1">'
        +'<stop offset="0" stop-color="#FFFFFF" stop-opacity="0.16"/>'
        +'<stop offset="0.42" stop-color="#FFFFFF" stop-opacity="0"/>'
      +'</linearGradient>'
      +'</defs>';

    // ---- helpers liés à la palette ----
    function plate(cx,cy,r){
      return '<circle cx="'+cx+'" cy="'+cy+'" r="'+r+'" fill="url(#be_gold)"/>'
        +'<circle cx="'+cx+'" cy="'+cy+'" r="'+r+'" fill="none" stroke="'+pal.goldD+'" stroke-width="1.5"/>'
        +'<circle cx="'+cx+'" cy="'+cy+'" r="'+f(r*0.72)+'" fill="url(#be_disc)"/>'
        +'<circle cx="'+cx+'" cy="'+cy+'" r="'+f(r*0.72)+'" fill="none" stroke="'+pal.gold+'" stroke-width="1.5"/>'
        +'<path d="'+starPath(cx,cy,r*0.5,r*0.22,0)+'" fill="url(#be_star)" stroke="'+pal.goldD+'" stroke-width="0.6"/>';
    }
    function laurel(cx,cy,rr,a0,a1){
      var s='', N=9;
      for(var i=0;i<=N;i++){
        var t=i/N, a=a0+(a1-a0)*t;
        var lx=cx+rr*Math.cos(a), ly=cy+rr*Math.sin(a);
        var deg=a*180/Math.PI+90;
        s+='<ellipse cx="'+f(lx)+'" cy="'+f(ly)+'" rx="6.4" ry="14.5" transform="rotate('+f(deg)+' '+f(lx)+' '+f(ly)+')" fill="url(#be_leaf)" stroke="'+pal.goldD+'" stroke-width="0.8"/>';
      }
      return s;
    }
    function cornerStar(x,y){ return '<path d="'+starPath(x,y,8,3.4,0)+'" fill="'+pal.gold+'" opacity="0.85"/>'; }

    // ---- BACKGROUND + CADRE ----
    var bg = '<rect width="800" height="1066" fill="'+pal.bg+'"/>'
      +'<rect width="800" height="1066" fill="url(#be_halo)"/>'
      +'<rect x="22" y="22" width="756" height="1022" rx="10" fill="none" stroke="url(#be_gold)" stroke-width="2.5" opacity="0.9"/>'
      +'<rect x="30" y="30" width="740" height="1006" rx="6" fill="none" stroke="'+pal.gold+'" stroke-width="0.8" opacity="0.5"/>'
      +cornerStar(48,48)+cornerStar(752,48)+cornerStar(48,1018)+cornerStar(752,1018);

    // ---- BLOC HAUT ----
    var top = '<line x1="286" y1="70" x2="358" y2="70" stroke="'+pal.gold+'" stroke-width="1.2"/>'
      +'<line x1="442" y1="70" x2="514" y2="70" stroke="'+pal.gold+'" stroke-width="1.2"/>'
      +'<path d="'+starPath(400,70,6,2.6,0)+'" fill="'+pal.gold+'"/>'
      +'<text x="400" y="76" text-anchor="middle" font-size="14" font-weight="600" letter-spacing="7" fill="'+pal.gold+'">'+discU+'</text>'
      +'<text x="400" y="'+(96+orgSize*0.5)+'" text-anchor="middle" font-size="'+orgSize+'" font-weight="800" letter-spacing="2" fill="'+pal.ink+'">'+orgU+'</text>'
      +'<line x1="250" y1="182" x2="372" y2="182" stroke="'+pal.gold+'" stroke-width="1" opacity="0.8"/>'
      +'<line x1="428" y1="182" x2="550" y2="182" stroke="'+pal.gold+'" stroke-width="1" opacity="0.8"/>'
      +'<path d="M400,174 L408,182 L400,190 L392,182 Z" fill="'+pal.gold+'"/>';

    // ---- CEINTURE : SANGLE ----
    var strap = '<rect x="56" y="460" width="688" height="156" rx="26" fill="url(#be_leather)"/>'
      +'<rect x="56" y="460" width="688" height="156" rx="26" fill="none" stroke="'+pal.strapD+'" stroke-width="3"/>'
      +'<rect x="61" y="465" width="678" height="58" rx="22" fill="#FFFFFF" opacity="0.06"/>'
      +'<rect x="76" y="478" width="648" height="120" rx="16" fill="none" stroke="'+pal.gold+'" stroke-width="1.4" stroke-dasharray="6 5" opacity="0.7"/>';
    var rivets = [[92,498],[708,498],[92,578],[708,578]].map(function(p){
      return '<circle cx="'+p[0]+'" cy="'+p[1]+'" r="5" fill="url(#be_gold)"/><circle cx="'+p[0]+'" cy="'+p[1]+'" r="5" fill="none" stroke="'+pal.goldD+'" stroke-width="0.8"/>';
    }).join('');

    // ---- PLAQUES LATÉRALES (4) ----
    var plates = plate(205,538,42)+plate(105,538,32)+plate(595,538,42)+plate(695,538,32);

    // ---- PLAQUE CENTRALE (bouclier) ----
    var shield = '<path d="'+shieldPath(400,330,705,150)+'" fill="url(#be_gold)"/>'
      +'<path d="'+shieldPath(400,330,705,150)+'" fill="none" stroke="'+pal.goldD+'" stroke-width="2"/>'
      +'<path d="'+shieldPath(400,346,689,134)+'" fill="url(#be_enamel)"/>'
      +'<path d="'+shieldPath(400,346,689,134)+'" fill="url(#be_gloss)"/>'
      +'<path d="'+shieldPath(400,346,689,134)+'" fill="none" stroke="'+pal.gold+'" stroke-width="1.5"/>'
      +'<path d="'+shieldPath(400,357,679,124)+'" fill="none" stroke="'+pal.goldD+'" stroke-width="0.8" opacity="0.55"/>'
      +'<text x="400" y="392" text-anchor="middle" font-size="'+orgTopSize+'" font-weight="700" letter-spacing="4" fill="'+pal.gold+'">'+shieldTopTxt+'</text>'
      // médaillon
      +'<circle cx="400" cy="470" r="96" fill="url(#be_disc)"/>'
      +'<circle cx="400" cy="470" r="96" fill="none" stroke="url(#be_gold)" stroke-width="3"/>'
      +'<circle cx="400" cy="470" r="96" fill="none" stroke="'+pal.goldD+'" stroke-width="1"/>'
      +'<circle cx="400" cy="470" r="86" fill="none" stroke="'+pal.gold+'" stroke-width="0.8" opacity="0.45"/>'
      // lauriers
      +laurel(400,470,105,rad(122),rad(240))
      +laurel(400,470,105,rad(58),rad(-60))
      // grande étoile
      +'<path d="'+starPath(400,468,66,28,0)+'" fill="url(#be_star)" stroke="'+pal.goldD+'" stroke-width="1.2"/>'
      +'<path d="'+starPath(400,468,66,28,0)+'" fill="none" stroke="'+pal.goldL+'" stroke-width="0.6" opacity="0.5"/>'
      +'<circle cx="400" cy="468" r="9" fill="url(#be_gold)" stroke="'+pal.goldD+'" stroke-width="0.7"/>'
      // banderole
      +'<path d="M270,580 L242,571 L256,600 L242,629 L270,620 Z" fill="'+pal.goldD+'" stroke="'+pal.goldD+'" stroke-width="1"/>'
      +'<path d="M530,580 L558,571 L544,600 L558,629 L530,620 Z" fill="'+pal.goldD+'" stroke="'+pal.goldD+'" stroke-width="1"/>'
      +'<rect x="270" y="580" width="260" height="40" fill="url(#be_goldH)" stroke="'+pal.goldD+'" stroke-width="1.5"/>'
      +'<line x1="270" y1="585" x2="530" y2="585" stroke="'+pal.goldL+'" stroke-width="1" opacity="0.5"/>'
      +'<text x="400" y="'+(600+nameSize*0.35)+'" text-anchor="middle" font-size="'+nameSize+'" font-weight="800" letter-spacing="1" fill="'+DK+'">'+nameU+'</text>'
      +'<text x="400" y="654" text-anchor="middle" font-size="12" font-weight="600" letter-spacing="5" fill="'+pal.gold+'">'+shieldBotTxt+'</text>';

    // ---- FLEURON INTER (entre ceinture et bloc bas) ----
    var midFlourish = '<path d="'+starPath(370,748,5,2,0)+'" fill="'+pal.gold+'" opacity="0.8"/>'
      +'<path d="'+starPath(400,748,7,2.8,0)+'" fill="'+pal.gold+'"/>'
      +'<path d="'+starPath(430,748,5,2,0)+'" fill="'+pal.gold+'" opacity="0.8"/>';

    // ---- BLOC BAS ----
    var bottom = '<line x1="250" y1="792" x2="372" y2="792" stroke="'+pal.gold+'" stroke-width="1" opacity="0.8"/>'
      +'<line x1="428" y1="792" x2="550" y2="792" stroke="'+pal.gold+'" stroke-width="1" opacity="0.8"/>'
      +'<path d="M400,784 L408,792 L400,800 L392,792 Z" fill="'+pal.gold+'"/>'
      +'<text x="400" y="852" text-anchor="middle" font-size="'+titleSize+'" font-weight="800" letter-spacing="4" fill="url(#be_gold)">'+titleU+'</text>'
      +'<text x="400" y="852" text-anchor="middle" font-size="'+titleSize+'" font-weight="800" letter-spacing="4" fill="none" stroke="'+pal.goldD+'" stroke-width="0.4" opacity="0.5">'+titleU+'</text>'
      +'<text x="400" y="888" text-anchor="middle" font-size="15" font-weight="600" letter-spacing="5" fill="'+pal.muted+'">'+bottomMeta+'</text>'
      +'<path d="'+starPath(360,924,6,2.4,0)+'" fill="'+pal.gold+'"/>'
      +'<line x1="376" y1="924" x2="424" y2="924" stroke="'+pal.gold+'" stroke-width="1" opacity="0.7"/>'
      +'<path d="'+starPath(400,924,6,2.4,0)+'" fill="'+pal.accent+'"/>'
      +'<line x1="376" y1="924" x2="424" y2="924" stroke="'+pal.gold+'" stroke-width="1" opacity="0.7"/>'
      +'<path d="'+starPath(440,924,6,2.4,0)+'" fill="'+pal.gold+'"/>';

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 1066" font-family="\'Sora\',\'Inter\',sans-serif">'
      + defs + bg + top + strap + rivets + plates + shield + midFlourish + bottom
      + '</svg>';
  }

  window.SNCombatBelt = { render: render, PALETTES: PALETTES };
})();